import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import type { AlertButton } from '@ionic/angular';

type AlertButtonActionHandler = AlertButton['handler'];

@Injectable({
  providedIn: 'root'
})
export class CommonAlertService {
  constructor(
    public alertController: AlertController
  ) { }

  async changeJurisdiction(confirmHandler: AlertButtonActionHandler) {
    const alert = await this.alertController.create({
      header: 'Are you sure you switch states?',
      message: 'Please note - your current session will be logged out.',
      mode: 'ios',
      cssClass: 'custom-alert',
      buttons: [
        {
          text: 'Cancel',
          cssClass: 'alert-button-cancel',
        },
        {
          text: 'Continue',
          cssClass: 'alert-button-primary',
          handler: confirmHandler
        },
      ],
    });

    await alert.present();
  }

  async showPepHioAlert(messageText?: string, callback?: any) {
    const alert = await this.alertController.create({
      cssClass: 'custom-alert',
      header: 'PEP/HIO Status',
      message: messageText || 'PEP/HIO Status: YES<br><br>You answered YES to this. Someone from support will reach out to you to help with the next steps.',
      buttons: [
        {
          text: 'OK',
          role: 'yes',
          cssClass: 'alert-button-cancel',
          handler: () => {
            if (callback) {
              callback();
            }
          }
        }
      ],
      backdropDismiss: false
    });
    await alert.present();
  }


}
